import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import RoomIcon from '@mui/icons-material/Room';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ModalDetalleProducto from "../modaldetalleproducto";

const DetalleProductos = ({ show, handleClose, producto }) => {
    const obtenerProductosURL = "https://invio.datachile.site/Web/Productos/ObtenerDetalleProductos.php";
    const [productos, setProductos] = useState([]);

    useEffect(() => {
        if (show && producto) {
            getProductos(producto.idDescripcion);
        }
    }, [show, producto]);

    const hexToText = (hex) => {
        let cleanHex = hex.replace(/\s+/g, '').replace(/0x/g, '');
        let result = '';
        for (let i = 0; i < cleanHex.length; i += 2) {
            result += String.fromCharCode(parseInt(cleanHex.substr(i, 2), 16));
        }
        return result;
    };

    const getProductos = async (idDescripcion) => {
        try {
            const userData = JSON.parse(localStorage.getItem('usuario'));
            const empresa_idEmpresa = userData ? userData.empresa_idEmpresa : null;
            if (!empresa_idEmpresa) {
                console.error('No se encontró empresa_idEmpresa en el localStorage.');
                return;
            }

            const response = await axios.post(obtenerProductosURL, { empresa_idEmpresa, idDescripcion });
            setProductos(response.data);
        } catch (error) {
            console.error('Error al obtener productos:', error);
        }
    };

    const deleteProducto = async (idProducto) => {
        try {
            const confirmDelete = window.confirm('¿Estás seguro de que deseas eliminar este producto?');
            if (!confirmDelete) {
                return;
            }

            await axios.post(`https://hermesrep.hermescloud.site/Web/Productos/EliminarProducto.php?id=${idProducto}`);
            getProductos(); // Recargar productos después de eliminar
        } catch (error) {
            console.error('Error al eliminar producto:', error);
        }
    };

    return (
        <Dialog
            open={show}
            onClose={handleClose}
            maxWidth="xl"
            fullWidth
        >
            <DialogTitle>
                Detalles del Producto
                <IconButton
                    edge="end"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="close"
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Container fluid>
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th>Descripción</th>
                                <th>Estado</th>
                                <th>Codigo</th>
                                <th>Ubicación</th>
                                <th>Fecha de registro</th>
                                <th>Coordenadas</th>
                                <th>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {productos.map((producto) => (
                                <tr key={producto.idProductos}>
                                    <td>{producto.descripcion}</td>
                                    <td>{producto.estado}</td>
                                    <td>{hexToText(producto.epc)}</td>
                                    <td>{producto.lugar}</td>
                                    <td>{producto.fecha_creacion}</td>
                                    <td>
                                        <a href={`https://www.google.com/maps/place/${producto.latitud},${producto.longitud}`} target="_blank" rel="noopener noreferrer">
                                            <RoomIcon sx={{ fontSize: 31 }} /> Ver
                                        </a>
                                    </td>
                                    <td style={{ display: 'flex', gap: '10px' }}>
                                        <Button
                                            variant="danger"
                                            onClick={() => deleteProducto(producto.idProductos)}
                                            style={{ Width: '30px', padding: '7px' }}
                                        >
                                            <DeleteForeverIcon fontSize="small" />
                                        </Button>
                                        <ModalDetalleProducto
                                            producto={producto.idProductos}
                                        />  
                                    </td>
                                </tr>
                            ))}
                            {productos.length === 0 && (
                                <tr>
                                    <td colSpan="7" className="text-center">No hay productos disponibles</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Container>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DetalleProductos;
